// extracted by css-extract-rspack-plugin
export default {"errorAlert":"errorAlert-xW6bfQ"};